import { Box, Container } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import AddNewMedicationModal from "../../../components/AddNewMedicationModal";
import Topbar from "../../../components/Topbar";
import { getAllPatientsModal } from "../../../services/patient";
import MarLogTab from "./MarLogTab";
import MedicationLogTab from "./MedicationLogTab";
import MarTab from "./MarTab";
import MedicationListTab from "./MedicationListTab";
import useStyles from "./style";
import { useDispatch, useSelector } from "react-redux";
import { getAllStaff } from "../../../services/staff";
import FilterBar from "./FilterBar";
import AddMedicationButton from "../../../components/AddMedicationButton/AddMedicationButton";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { setSelectedClient } from "../../../store/reducers/mar";
import { getAllSignatures } from "../../../services/signature";
import { useLocation } from "react-router-dom";
import { decrypt } from "../../../utils";

export const getColor = (key) => {
  const color = {
    Taken: { dark: "#8ed383", light: "rgba(29, 167, 6, 0.15)" },
    Missed: { dark: "#ff9999", light: "rgba(255, 0, 0, 0.15)" },
    Refused: { dark: "#c7daf5", light: "rgba(199, 218, 245, 0.25)" },
    upcoming: { dark: "#cbcbcb", light: "#cbcbcb" },
    // discontinued:{ dark: "#A52A2A", light: "#8B4513" },
    "Unable to Take": { dark: "#ffff80", light: "rgba(255, 255, 0, 0.15)" },
    "Out of Medication": { dark: "#000", light: "#000" },
    PRN: { dark: "#bf80bf", light: "rgba(128, 0, 128, 0.15)" },
  };
  return color[key];
};

const Medication = ({ userId, tabName }) => {
  const { classes } = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const [view, setView] = useState("calendar");
  const [medicine, setMedicine] = useState(null);
  const [isPreview, setIsPreview] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [activeTab, setActiveTab] = useState("medicationList");
  const [opened, { open, close }] = useDisclosure(false);
  const { profile } = useSelector((state) => state?.profile);
  const { selectedClient } = useSelector((state) => state.mar);

  // Handle notification medication on mount
  useEffect(() => {
    const notificationData = location?.state?.medication;

    if (notificationData?.client?.form3 && notificationData?.moduleId) {
      const medicationsArray = decrypt(notificationData.client.form3);
      const targetMedication = medicationsArray?.find(
        (med) => med?.id === Number(notificationData.moduleId)
      );
      if (targetMedication) {
        setMedicine(targetMedication);
        setIsPreview(true);
        open();
      }
    }
  }, [location?.state?.medication, open]);

  useEffect(() => {
    if (tabName) {
      setActiveTab(tabName);
    }
  }, [tabName]);

  useEffect(() => {
    TrackPageView("Medication");
    getAllSignatures();
  }, []);

  useEffect(() => {
    if (activeTab === "medicationList") {
      getAllPatientsModal();
    }
  }, [activeTab]);

  useEffect(() => {
    getAllStaff("withAdmin");
    return () => {
      localStorage.setItem("tab", "medicationList");
      localStorage.removeItem("selectedClient");
    };
  }, []);

  const handleTabChange = (val) => {
    setShouldRefresh(true);
    setTimeout(() => setActiveTab(val), 200);
    localStorage.setItem("tab", val);

    dispatch(setSelectedClient(selectedClient));
    localStorage.setItem("selectedClient", JSON.stringify(selectedClient));
    // setLocalSelectedClient(obj);
  };

  return (
    <Box className={classes.content}>
      <AddNewMedicationModal
        opened={opened}
        onclose={(nType) => {
          close();
          setMedicine(null);
          if (isPreview) setIsPreview(false);
        }}
        data={medicine}
        title={"Chloroquine"}
        userId={userId}
        isPreview={isPreview}
      />

      {!userId ? (
        <>
          <AppNavbar title="Medication" profile={profile} />
          <div className={classes.mainHeading}></div>
        </>
      ) : (
        ""
      )}
      <Box px={20} mt={20}>
        {!userId ? (
          <div className={classes.tabs}>
            <p
              id="medication-list-click"
              onClick={() => handleTabChange("medicationList")}
              className={activeTab === "medicationList" ? classes.active : ""}
            >
              Medication List
            </p>
            {/* <p
              onClick={() => handleTabChange("medicationLog")}
              className={activeTab === "medicationLog" ? classes.active : ""}
            >
              Medication Log
            </p> */}
            <p
              id="mar-click"
              onClick={() => handleTabChange("mar")}
              className={activeTab === "mar" ? classes.active : ""}
            >
              MAR
            </p>
            <p
              id="mar-log"
              onClick={() => handleTabChange("marLog")}
              className={activeTab === "marLog" ? classes.active : ""}
            >
              Log
            </p>
          </div>
        ) : (
          ""
        )}

        <div className={classes.bar} style={{ marginBottom: "10px" }}>
          <div className={classes.left}>
            {activeTab === "mar" && (
              <>
                <div
                  className={`${classes.iconBar} ${
                    view === "list" ? classes.iconBarActive : ""
                  }`}
                  onClick={() => {
                    setShouldRefresh(false);
                    setTimeout(() => {
                      setView("list");
                    }, 200);
                  }}
                >
                  <img
                    src={"/assets/images/icons8-menu-24 33.png"}
                    alt="menu"
                  />
                </div>
                <div
                  className={`${classes.iconBar} ${
                    view === "calendar" ? classes.iconBarActive : ""
                  }`}
                  onClick={() => {
                    setActiveTab("mar");
                    setView("calendar");
                  }}
                >
                  <img
                    src={"/assets/images/icons8-calendar-96 3.png"}
                    alt="menu"
                  />
                </div>
              </>
            )}
          </div>
          <AddMedicationButton
            userId={userId}
            selectedClient={selectedClient}
          />
        </div>

        <FilterBar activeTab={activeTab} />

        {activeTab === "medicationList" && (
          <MedicationListTab
            userId={userId}
            clientId={selectedClient?.id}
            onEditClick={(data, isPreview) => {
              setMedicine(data);
              open();
              if (isPreview) setIsPreview(true);
            }}
          />
        )}
        {activeTab === "mar" && (
          <MarTab userId={userId} view={view} activeTab={activeTab} />
        )}
        {activeTab === "marLog" && (
          <MarLogTab
            userId={userId}
            activeTab={activeTab}
            refresh={shouldRefresh}
          />
        )}
        {/* {activeTab === "medicationLog" && (
          <MedicationLogTab activeTab={activeTab} refresh={shouldRefresh} />
        )} */}
      </Box>
    </Box>
  );
};

export default Medication;
